import type { MapLayerMouseEvent } from "maplibre-gl";

import { Popup } from "maplibre-gl";
import { extend } from "maplibre-gl/src/util/util";
import type { Map } from "~/ui/map";
import type { LayerFilter, LayerInstanceOptions } from "./layer_instance";
import { LayerInstance } from "./layer_instance";

export const truckSourceName = 'ndrive-truck';

const defaultOptions: LayerInstanceOptions = {
    initialEnabled: false
};

const truckLayers = {
    "truck_restrictions_truck_forbidden": "Truck restricted",
    "truck_restrictions_height": "Height restriction: ${height_formatted}${length_unit}",
    "truck_restrictions_weight": "Weight restriction: ${weight_formatted}${weight_unit}",
    "truck_restrictions_hazmat": "Hazmat restriction: ${hazmat_prohibition}",
    "truck_restrictions_trailer_prohibition": "Trailer prohibition",
    "truck_restrictions_102_length": "102\" width restriction",
    "truck_restrictions_trailer_length": "Trailer length restriction: ${trailer_length_prohibition_formatted}${length_unit}",
    "truck_restrictions_trailer_weight": "\
        <div>\
            <p class=\"truck-trailer-header\">Trailer weight restriction:</p>\
            <p class=\"truck-trailer\">No trailers: ${weight_0_trailer_formatted}${weight_unit}</p>\
            <p class=\"truck-trailer\">Single: ${weight_1_trailer_formatted}${weight_unit}</p>\
            <p class=\"truck-trailer\">Double: ${weight_2_trailer_formatted}${weight_unit}</p>\
            <p class=\"truck-trailer\">Triple: ${weight_3_trailer_formatted}${weight_unit}</p>\
        </div>\
    ",
    "truck_restrictions_max_axles": "Axles number restriction: ${max_axle_count} or more"
};

export class TruckRestrictionsLayer extends LayerInstance {
    static readonly id = "nmapsgl_truck_restrictions";
    static readonly title = "Truck Restrictions";

    private popup: Popup;

    constructor(options?: LayerInstanceOptions) {
        options = extend({}, defaultOptions, options);
        const filters: LayerFilter[] = [
            {
                id: TruckRestrictionsLayer.title,
                filter: l => l[ "source" ] === truckSourceName,
            }
        ];
        super(filters, options);
    }

    onAdd(map: Map): void {
        super.onAdd(map);
        for (const l of Object.keys(truckLayers)) {
            this.map.on("mouseenter", l, this.onMouseEnter);
            this.map.on("mouseleave", l, this.onMouseLeave);
            this.map.on("click", l, this.renderPopup);
        };
        
        this.on("change", this.onChange);
    }

    onRemove(): void {
        for (const l of Object.keys(truckLayers)) {
            this.map.off("mouseenter", l, this.onMouseEnter);
            this.map.off("mouseleave", l, this.onMouseLeave);
            this.map.off("click", l, this.renderPopup);
        };
        this.off("change", this.onChange);
        super.onRemove();
    }

    private onMouseEnter = () => {
        this.map.getCanvas().style.cursor = "pointer";
    };

    private onMouseLeave = () => {
        this.map.getCanvas().style.cursor = "";
    };

    private onChange = () => {
         if (this.popup) {
            this.popup.remove();
            delete this.popup;
        }
    }

    private renderPopup = (e: MapLayerMouseEvent) => {
        

        if (this.popup) this.popup.remove();
        this.popup = new Popup({ closeButton: false, offset: [ 0, -5 ], className: "nmapsgl-truck-restrictions-popup" })
            .setLngLat(e.lngLat)
            .setHTML(this.getHTMLPopUp(e.features[ 0 ]))
            .addTo(this.map);
    };

    getHTMLPopUp(feature) {
        const layerId = feature.layer.id;
        return truckLayers[layerId].replace(/\${([^}]+)}/g, (match, key) => feature.properties[key] || "").replace(/\s*:\s*$/, "").trim();
    }

}
